import type { ChartPadding } from './types';

export const DEFAULT_CHART_PADDING: ChartPadding = { top: 8, right: 8, bottom: 8, left: 8 };
export const DEFAULT_CHART_LABEL_PADDING: Partial<ChartPadding> = { right: 72, bottom: 28 };
export const LABEL_PADDING_VERTICAL = 8;
